<template>
    <div class="verify-body">
        <div class="container">
            <img src="../../assets/img/Notica-logo.png" alt="Notica Logo">
            <p>لطفا کد ارسال شده به این شماره را وارد کنید</p>
            <span class="phone">{{ phone }}</span>
        </div>
        <div>
            <form class="verify-form" @submit.prevent="verifyCode">
                <div class="verify-code">
                    <input class="verify-input code-1" type="number" placeholder="" name="code" id="code" required pattern="[0-9]{1}" title="" maxlength="1"> 
                    <input class="verify-input code-2" type="number" placeholder="" name="code" id="code" required pattern="[0-9]{1}" title="" maxlength="1"> 
                    <input class="verify-input code-3" type="number" placeholder="" name="code" id="code" required pattern="[0-9]{1}" title="" maxlength="1"> 
                    <input class="verify-input code-4" type="number" placeholder="" name="code" id="code" required pattern="[0-9]{1}" title="" maxlength="1"> 
                    <input class="verify-input code-5" type="number" placeholder="" name="code" id="code" required pattern="[0-9]{1}" title="" maxlength="1"> 
                </div>
                <span class="change-number" href="#">ویرایش شماره؟</span>
                <input type="submit" name="submit" id="submit" class="verify-btn" value="تایید">
            </form>
        </div>
        <div class="overlay" v-if="loading">
            <div class="loader">
                <div class="circle"></div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    props: {
        phone: String
    },
    data() {
        return {
            currentPage: 2,
            loading: false
        }
    },
    mounted() {
        console.log(this.phone);
        const codeInputs = document.querySelectorAll('.verify-input');
        codeInputs.forEach((input, index) => {
            input.addEventListener('input', () => {
                if (input.value !== '') {
                    if (index < codeInputs.length - 1) {
                        codeInputs[index + 1].focus();
                    } else {
                        const verifyBtn = document.querySelector('.verify-btn');
                        verifyBtn.focus();
                    }
                }
            });
        });
        // focus on first input
        codeInputs[0].focus();

        // on delete key press
        codeInputs.forEach((input, index) => {
            input.addEventListener('keydown', (e) => {
                if (e.key === 'Backspace') {
                    input.value = ''; // clear current input
                    if (index > 0) {
                        codeInputs[index - 1].focus();
                    }
                }
            });
        })
    },
    methods: {
        async verifyCode() {
            console.log('verify hoi')
            const codeInputs = document.querySelectorAll('.verify-input');
            let code = '';
            codeInputs.forEach(input => {
                code += input.value;
            });
            console.log('Verification code:', code);
            console.log('Verification phone:', this.phone);
            this.loading = true
            try {
                let response = await axios.post('https://api.noticapp.ir/v1/auth/verify-phone', {
                    headers: {
                        accept: 'application/json',
                        contentType: 'application/json',
                    },
                    phone: this.phone,
                    code: code
                });

                if (response.data.status === 'error') {
                    alert(response.data.message);
                } else {
                    const token = response.data.auth.token;
                    localStorage.setItem('token', token);
                    this.$router.push({ name: 'home' });
                }
            } catch (error) {
                if (error.response) {
                    alert(error.response.data.message);
                } else {
                    console.error('خطای ناشناخنه رخ داده است: ', error);
                }
            } finally {
                this.loading = false;
            }
        }
    }

}
</script>

<style scoped>
    .verify-body {
        background-color: #25292E;
        height: 100vh;
        align-items: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 25px;
    }
    img {
        width: 215px;
        height: 200px;
    }
    p {
        font-size: 18px;
        color: #fff;
    }

    .phone {
        font-size: 22px;
        color: #fff;
    }

    .verify-form {
        display: flex;
        flex-direction: column;
        gap: 15px;
    }

    .change-number {
        color: #c41b67;
        font-size: 15px;
        text-decoration: none;
        align-self: center;
        cursor: pointer;
    }

    .verify-code {
        display: flex;
        gap: 10px;
        justify-content: center;
        flex-direction: row-reverse;
    }

    .verify-input {
        border: none;
        border-radius: 20px;
        /* padding: 15px; */
        font-size: 15px;
        width: 35px;
        height: 40px;
        transition: all 0.3s;
        text-align: center;
        align-self: center;
        display: flex;
        justify-content: center;
        align-items: center;
        direction: ltr;
        
    }

    .verify-input:focus {
        border: none;
        outline: none;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
        
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type=number] {
        -moz-appearance: textfield;
    }
    .verify-btn {
        background-color: #028D92;
        color: white;
        border: none;
        border-radius: 20px;
        font-size: 22px;
        cursor: pointer;
        width: 175px;
        height: 40px;
        align-self: center;
    }

    .overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.8); /* پس‌زمینه نیمه‌شفاف */
        display: flex;
        justify-content: center;
        align-items: center;
        backdrop-filter: blur(5px); /* افکت مات */
        z-index: 1000; /* بالاتر از همه عناصر */
    }

    .loader {
        background: transparent;
        width: 80px;
        height: 80px;
        border-radius: 50%;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .circle {
    width: 80px;
    height: 80px;
    border: 3px solid #028d92;
    position: absolute;
    border-radius: 50%;
    animation: circle14512 1.5s linear infinite;
    }

    .circle::before {
    content: '';
    position: absolute;
    top: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #cc0066;
    box-shadow: 0 0 10px #cc0066, 0 0 20px #cc0066;
    }

    @keyframes circle14512 {
        0% {
            transform: rotate(0deg);
        }

        100% {
            transform: rotate(360deg);
        }
    }

</style>